<template>
  <div>
    <div class="page_container warehousingRecordPage">
      <div class="main_container">
        <div
          class="list_wrap flex-rowl"
          v-loading="loading"
          :element-loading-text="$t('Please wait')"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.4)"
        >
          <template v-if="dataList.length > 0">
            <div
              class="item_wrap flex-rowl"
              v-for="item in dataList"
              :key="item.id"
            >
              <div class="pic_box">
                <el-image
                  style="width: 140px; height: 140px"
                  :src="item.img"
                  fit="cover"
                  :preview-src-list="item.bannerList"
                >
                  <div slot="error" class="image-slot flex-rowc">
                    <i class="iconfont icon-zanwutupian1"></i>
                  </div>
                </el-image>
              </div>
              <div class="intro_box">
                <!-- <div class="block">
                  <p class="small">
                    {{ item.commodityname_e }}
                    <span
                      class="copy_box"
                      :data-clipboard-text="item.commodityname_e"
                      @click="handleCopyBtn"
                      v-if="item.commodityname_e"
                      ><i class="iconfont icon-fuzhi"></i
                    ></span>
                  </p>
                </div> -->
                <div class="block">
                  <p>
                    {{ item.multilingualCommodityname }}
                    <span
                      class="copy_box"
                      :data-clipboard-text="item.multilingualCommodityname"
                      @click="handleCopyBtn"
                      v-if="item.multilingualCommodityname"
                      ><i class="iconfont icon-fuzhi"></i
                    ></span>
                  </p>
                </div>
                <div class="block label" v-if="item.labelsstr.length > 0">
                  <template v-for="(itemChild, indexChild) in item.labelsstr">
                    <span :key="indexChild" v-if="itemChild.labelstate == 1"
                      ># {{ itemChild.multilingualName }}</span
                    >
                  </template>
                </div>
                <div class="block">
                  <p class="small">
                    {{ $t("Brand Name") }}：
                    {{ item.qyename ? item.qyename : item.qy_accountid }}
                  </p>
                  <!-- <p class="small">
                    SKU ID : {{ item.sku }}
                    <span
                      class="copy_box"
                      :data-clipboard-text="item.sku"
                      @click="handleCopyBtn"
                      v-if="item.sku"
                      ><i class="iconfont icon-fuzhi"></i
                    ></span>
                  </p> -->
                </div>
                <div class="block">
                  <p>{{ $t("Reference Retail Price") }}</p>
                  <p v-if="item.multilingualPrice">
                    ({{ COUNTRY.moneyslog }}) :{{ item.multilingualPrice }}
                    <span
                      class="copy_box"
                      :data-clipboard-text="item.multilingualPrice"
                      @click="handleCopyBtn"
                      ><i class="iconfont icon-fuzhi"></i
                    ></span>
                  </p>
                  <p v-else>
                    ({{ COUNTRY.moneyslog }}) :
                    <span class="update">显示最新价格信息</span>
                  </p>
                </div>
              </div>
            </div>
          </template>
          <div
            class="empty_box flex-rowc"
            v-if="!loading && dataList.length == 0"
          >
            <el-empty :description="$t('No data yet')"></el-empty>
          </div>
        </div>
      </div>
      <!-- 分页 start -->
      <div class="pagination_wrap flex-rowc">
        <!-- jumper -->
        <el-pagination
          @current-change="handleCurrentChange"
          layout="prev, pager, next"
          :page-size="9"
          :total="listTotal"
          :current-page="params.Page"
        >
        </el-pagination>
      </div>
      <!-- 分页 end -->
    </div>
  </div>
</template>

<script>
import { getCommonditySpecial } from "../api/api";
import { mapState } from "vuex";
import Clipboard from "clipboard";
export default {
  name: "HomeVisitors",
  data() {
    return {
      loading: false,
      dataList: [],
      params: {
        Page: 1,
        PageSize: 9,
        typeid: "",
        keyword: "",
        istop: "",
        comtype: "",
        scorewide: "",
        isintro: "", // 推荐 1 非推荐的 0， 留空则显示全部
        labels: "", // 可以输入特定标签，比如 爆款 新品
        ordertype: "", // 1 综合排序 2价格升序  3 价格降序 4积分升序  5积分降序
        brandid: "",
        commoditystate: 1, // 1 上架 0 下架 2 全部 留空为上架
        qyid: "",
        countryid: "", // 根据国家屏蔽特定的企业 countryid从接口549获取
        fav_openid: "",
        labelid: "",
        labelid2: "",
        labelid3: "",
      },
      listTotal: 0,
    };
  },
  // 监听this.$store.state.COUNTRY的变化
  watch: {
    "COUNTRY.countryid": {
      handler(val) {
        this.params.countryid = val? parseInt(val) : 1;
        this.initData();
      },
      immediate: true,
    },
  },
  computed: {
    ...mapState(["COUNTRY"]),
  },
  created() {
    let { COUNTRY } = this.$store.state;
    this.params.countryid = COUNTRY.countryid ? parseInt(COUNTRY.countryid) : 1;
    this.initData();
  },
  methods: {
    handleMultilingualName(dataList, key1, key2, key3, key4) {
      let { countryid } = this.COUNTRY;
      dataList.forEach((v) => {
        if (countryid == 1) {
          v.multilingualName = v[key1];
        } else if (countryid == 8) {
          // 英文
          v.multilingualName = v[key2] ? v[key2] : v[key1];
        } else if (countryid == 2) {
          // 俄语
          v.multilingualName = v[key3] ? v[key3] : v[key2] ? v[key2] : v[key1];
        } else if (countryid == 4) {
          // 越语
          v.multilingualName = v[key4] ? v[key4] : v[key2] ? v[key2] : v[key1];
        }
      });
      return dataList;
    },

    handleCurrentChange(e) {
      this.params.Page = e;
      // this.dataList = [];
      this.initData();
    },

    initData() {
      let { params } = this;
      this.loading = true;
      getCommonditySpecial(params).then((res) => {
        res.list.forEach((v) => {
          // 不同国家选择多语言
          if (params.countryid == 1) {
            v.multilingualPrice = v.price;
            v.multilingualCommodityname = v.commodityname;
          } else if (params.countryid == 8) {
            // 英文
            v.multilingualPrice = v.ams_shop_commodity_exrate.ame_price
              ? v.ams_shop_commodity_exrate.ame_price
              : "";
            v.multilingualCommodityname = v.commodityname_e
              ? v.commodityname_e
              : "";
          } else if (params.countryid == 2) {
            // 俄语
            v.multilingualPrice = v.ams_shop_commodity_exrate.lu_price
              ? v.ams_shop_commodity_exrate.lu_price
              : "";
            v.multilingualCommodityname = v.commodityname_m
              ? v.commodityname_m
              : v.commodityname_e
              ? v.commodityname_e
              : "";
          } else if (params.countryid == 4) {
            // 越语
            v.multilingualPrice = v.ams_shop_commodity_exrate.yue_price
              ? v.ams_shop_commodity_exrate.yue_price
              : "";
            v.multilingualCommodityname = v.commodityname_y
              ? v.commodityname_y
              : v.commodityname_e
              ? v.commodityname_e
              : "";
          }

          this.handleMultilingualName(
            v.labelsstr ? v.labelsstr : [],
            "labelname",
            "labelname_e",
            "labelname_m",
            "labelname_y"
          );

          const filteredArr = Object.keys(v)
            .filter((key) => key.startsWith("banner"))
            .map((key) => v[key]);
          v.bannerList = filteredArr.filter(
            (item) => item !== null && item !== undefined && item !== ""
          );
        });

        this.listTotal = res.total;
        this.dataList = res.list;
        this.loading = false;
      });
    },

    // 复制
    handleCopyBtn() {
      let clipboard = new Clipboard(".copy_box");
      clipboard.on("success", () => {
        // console.log("复制成功",e);
        this.$message.success(this.$t("Copy successful"));
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        console.log("该浏览器不支持自动复制", e);
        if (e.text) {
          this.$message.warning("SAO chép không thành công");
        } else {
          // this.$toast("暂无内容");
        }
        // 释放内存
        clipboard.destroy();
      });
    },
  },
};
</script>
<style lang="less" scoped>
.page_container {
  .order_tip {
    height: 50px;
    background: #efefef;
    margin-bottom: 15px;
    padding: 0 10px;
    box-sizing: border-box;
    p {
      font-size: 16px;
      color: #000000;
      cursor: pointer;
      margin-left: 10px;
      span {
        color: red;
      }
    }
  }
  .screen_wrap {
    font-size: 16px;
    color: #5b5b5b;
    margin-bottom: 15px;
    flex-wrap: wrap;

    .mr_15 {
      margin-right: 15px;
    }
    i {
      cursor: pointer;
      color: #303030;
      display: inline-block;
    }
    .rest_box {
      height: 36px;
      width: 11%;
      flex-shrink: 0;
      cursor: pointer;
      .iconfont {
        margin-left: 5px;
      }
    }
    .ordertype_box {
      height: 36px;
      width: 19%;
      flex-shrink: 0;
      margin: 0 20px;
      .iconfont {
        font-size: 20px;
      }
    }
    .query_box {
      // span {
      //   width: 25%;
      //   white-space: nowrap;
      // }
      // width: 22%;
      flex-shrink: 0;
      margin-right: 20px;
      .label {
        height: 100%;
        white-space: nowrap;
        margin-right: 10px;
      }
      height: 36px;
      .select_box,
      .input_box {
        width: 200px;
        height: 36px;
        background: #e6e6e6;
        border-radius: 45px;
        position: relative;
        cursor: pointer;
        padding: 0 30px 0 10px;
        box-sizing: border-box;
        &.select_box1 {
          width: 150px;
        }
        p {
          font-size: 14px;
          color: #acacac;
          width: 100%;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          &.active {
            color: #303030;
          }
        }
        /deep/ .el-input__inner {
          background: transparent;
          height: 36px;
          line-height: 36px;
          border: none;
          padding: 0;
        }
        /deep/ .el-select .el-input .el-select__caret {
          color: #e6e6e6;
        }
        .iconfont {
          position: absolute;
          right: 15px;
          color: #acacac;
        }
        &.label_box {
          width: 200px;
        }
        // span {
        //   position: absolute;
        //   right: 14px;
        //   top: 50%;
        //   transform: translateY(-50%);
        //   color: #666666;
        // }
      }
      .input_box {
        .iconfont {
          right: 10px;
          cursor: pointer;
        }
      }
      &:last-child {
        margin-right: 0;
      }
    }
  }
  .country_wrap {
    margin: 40px auto 50px;
    .tit {
      text-align: center;
      font-size: 18px;
      color: red;
      margin-bottom: 20px;
    }
    .radio_wrap {
      flex-wrap: wrap;
      .radio_item {
        min-width: 140px;
        height: 35px;
        border-radius: 25px;
        border: 2px solid #f3f3f3;
        padding-left: 6px;
        box-sizing: border-box;
        margin-right: 30px;
        margin-bottom: 20px;
        .radio {
          font-size: 14px;
          color: #333333;
          margin-right: 40px;
          position: relative;
          cursor: pointer;
          &:last-child {
            margin-right: 0;
          }
          .icon-quanxuan {
            font-size: 22px;
            margin-right: 7px;
            color: #bbbbbb;
          }
          &.active {
            .icon-quanxuan {
              color: #595a5a;
            }
          }
        }
        img {
          margin-right: 5px;
        }
        &:last-child {
          margin-right: 0;
        }
        &.active {
          border: 2px solid #033333;
          .icon-quanxuan {
            color: #595a5a;
          }
        }
      }
    }
  }
  .label_wrap {
    margin-bottom: 30px;
    font-size: 16px;
    color: #333333;
    align-items: flex-start;
    .label_content {
      align-items: flex-start;
    }
    .label {
      margin-right: 15px;
      white-space: nowrap;
    }
    .label_list {
      flex-wrap: wrap;
      align-items: flex-start;
      .label_item {
        cursor: pointer;
        margin-right: 35px;
        white-space: nowrap;
        margin-bottom: 10px;
        &.red {
          color: #ff0000;
        }
        .iconfont {
          color: #b7b7b7;
          font-size: 18px;
          margin-right: 5px;
          &.icon-danxuanyixuan1 {
            color: #ea4e4e;
          }
        }
      }
    }
    .label_more {
      cursor: pointer;
      white-space: nowrap;
      p {
        margin-right: 5px;
      }
    }
  }
  .list_wrap {
    height: auto;
    align-items: flex-start;
    flex-flow: wrap;
    min-height: 80vh;

    .item_wrap {
      background: none;
      width: calc((100% - 120px) / 3);
      align-items: flex-start;
      margin-bottom: 30px;
      flex-shrink: 0;
      &:nth-child(3n-1) {
        margin-left: 60px;
        margin-right: 60px;
      }
      .intro_box {
        margin: 0 0 0 20px;
        flex: 1;
      }
      .block {
        margin-bottom: 10px;

        .copy_box {
          cursor: pointer;
        }
        p {
          font-size: 16px;
          color: #333333;
          line-height: 18px;
          line-break: anywhere;
          &.small {
            font-size: 14px;
            line-height: 15px;
            margin-bottom: 5px;
          }
        }
        .update {
          cursor: pointer;
          color: #5771ab;
        }
      }
      .shop_operation_wrap {
        margin-top: 15px;
        flex-wrap: wrap;
        .shop_operation_item {
          cursor: pointer;
          margin-bottom: 20px;
          margin-right: 20px;
          &:last-child {
            margin-right: 0;
          }
        }
        .add_order_btn {
          // width: 165px;
          height: 29px;
          background: #225476;
          border-radius: 45px;
          font-size: 14px;
          color: #ffffff;
          position: relative;
          padding: 0 20px 0 50px;
          .icon {
            flex-shrink: 0;
            height: 39px;
            width: 39px;
            border-radius: 50%;
            border: 2px solid #225476;
            box-sizing: border-box;
            background: #fff;
            left: 0;
            position: absolute;
            padding-left: 5px;
            box-sizing: border-box;
            margin-bottom: 0;
          }
          p {
            white-space: nowrap;
          }
        }
      }
    }
    .label {
      color: #5771ab;
      span {
        margin-right: 20px;
        display: inline-block;
      }
    }
    .empty_box {
      width: 100%;
      height: 100%;
    }
  }
  .custom_dialog {
    .diaog_head {
      height: 60px;
    }
    .diaog_body {
      height: calc(68vh - 120px);
      .radio_wrap {
        .radio_group {
          p {
            margin-bottom: 20px;
          }
          .radio_list {
            flex-wrap: wrap;
          }
          .radio_item {
            margin-right: 80px;
            font-size: 14px;
            color: #6e6e6e;
            margin-bottom: 20px;
            cursor: pointer;
            .iconfont {
              font-size: 20px;
              margin-right: 5px;
              color: #a5a5a5;
              &.icon-danxuanyixuan1 {
                color: #ea4e4e;
              }
            }
            &.red {
              color: #ff0000;
            }
          }
          &.mb_30 {
            margin-bottom: 20px;
          }
        }
      }
    }
    .form_footer {
      height: 70px;
      padding: 0 20px;
      box-sizing: border-box;
      border-top: 1px solid #f7f7f7;
    }

    .userInfo_wrap {
      min-width: 700px;
      width: auto;
      height: auto;
      background: #f6f6f6;
      .close_wrap {
        padding: 0 15px;
        box-sizing: border-box;
        height: 45px;
        align-items: flex-end;
        .icon-guanbi {
          font-size: 26px;
          cursor: pointer;
          color: #595959;
        }
      }
      .diaog_body {
        margin-top: 0;
        height: 100%;
        padding-bottom: 20px;
        box-sizing: border-box;
        .tip {
          font-size: 20px;
          color: #6e6e6e;
          span {
            margin-left: 9px;
          }
        }
        .tit {
          font-size: 18px;
          color: #333333;
          margin: 42px 0 40px;
        }
        .content_list {
          .item {
            margin-right: 30px;
            border: 3px dashed #626262;
            background: #fff;
            border-radius: 30px;
            padding: 37px 60px 62px;
            box-sizing: border-box;
            &:last-child {
              margin-right: 0;
            }
            .btn {
              font-size: 20px;
              color: #333333;
              background: url(../assets/images/btn_bg.png) no-repeat center;
              background-size: cover;
              width: 238px;
              height: 58px;
              position: relative;
              margin-top: 13px;
              cursor: pointer;
              &::after {
                display: inline-block;
                content: "";
                background: url(../assets/images/set_icon.png) no-repeat center;
                background-size: cover;
                width: 31px;
                height: 30px;
                position: absolute;
                left: 12px;
                top: 50%;
                transform: translateY(-50%);
              }
            }
            &.disable {
              // 整体模块颜色灰处理
              background: #e6e6e6;
            }
          }
        }
      }
    }
  }
  .rest_wrap {
    font-size: 12px;
    cursor: pointer;
    color: #444;
    height: 35px;
    border: 1px solid #d8d8d8;
    border-radius: 20px;
    padding: 0 14px 0 28px;
    box-sizing: border-box;
    margin-left: 20px;
    span {
      margin-right: 10px;
    }
  }

  // .main_container {
  //   .select_add {
  //     // p {
  //     //   &:last-child {
  //     //     margin-left: 49px;
  //     //   }
  //     // }
  //   }
  //   .shop_list {
  //     .shop_more {
  //       height: 50px;
  //       border-top: 1px solid #fff;
  //     }
  //   }
  //   .red {
  //     color: #ee0032;
  //   }
  // }
  // .intro_box {
  //   cursor: pointer;
  //   .shop_item {
  //     margin-bottom: 5px;
  //     font-size: 14px;
  //   }
  // }
}
</style>